module.exports = __webpack_public_path__ + "media/tr_tr_s3_Filiz.2b10b4ce.mp3";